type ReleaseList = Array<{ start: string; end?: string }>;

export type AvailabilityStatus =
  | 'Coming soon'
  | 'Out now'
  | 'Retired'
  | 'Unknown';

export type Availability = {
  status: AvailabilityStatus;
  date?: string;
  text?: string;
};

const dateFormat = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
} as const;

const getAvailabilty = (releaseList: ReleaseList): Availability => {
  if (!releaseList || releaseList.length === 0) {
    return {
      status: 'Unknown',
    };
  }

  const now = new Date();

  const latestRelease = releaseList.reduce((a, b) => {
    return new Date(a.start) > new Date(b.start) ? a : b;
  });

  const start = new Date(latestRelease.start.replace(/-/g, '/'));
  const end = latestRelease.end
    ? new Date(latestRelease.end.replace(/-/g, '/'))
    : undefined;

  if (now.getTime() > start.getTime()) {
    if (end && now.getTime() > end.getTime()) {
      return {
        status: 'Retired',
        date: end.toLocaleDateString(undefined, dateFormat),
      };
    }
    return {
      status: 'Out now',
    };
  }

  const availableDate = start.toLocaleDateString(undefined, dateFormat);

  return {
    status: 'Coming soon',
    date: availableDate,
    text: availableDate,
  };
};

export default getAvailabilty;
